import { render, staticRenderFns } from "./xuzyfk_config.vue?vue&type=template&id=212aa534&scoped=true"
import script from "./xuzyfk_config.vue?vue&type=script&lang=js"
export * from "./xuzyfk_config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212aa534",
  null
  
)

export default component.exports